import * as React from 'react'

import { styled } from '~/styled'

import { Text } from '../../text/Text'
import { useBannerContext } from '../BannerContext'

const StyledText = styled(
  Text,
  {
    base: ['text-(--banner-heading-color)'],
    variants: {
      containerSize: {
        sm: [],
        md: []
      },
      hasDismiss: {
        true: []
      }
    },
    compoundVariants: [
      {
        containerSize: 'sm',
        hasDismiss: true,
        class: ['mr-10']
      }
    ]
  },
  {
    enabledResponsiveVariants: true
  }
)

export const BannerSlimText = (
  props: React.ComponentPropsWithoutRef<typeof Text>
) => {
  const { size, hasDismiss } = useBannerContext()

  return (
    <StyledText
      size="md"
      weight="bold"
      containerSize={size}
      hasDismiss={hasDismiss}
      noCapsize
      {...props}
    />
  )
}

BannerSlimText.displayName = 'BannerSlimText'
